import axios, { AxiosHeaders } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://kashround.test';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/partner`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const headers = AxiosHeaders.from(config.headers);
  const match = document.cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='));
  if (match) {
    headers.set('X-XSRF-TOKEN', decodeURIComponent(match.slice('XSRF-TOKEN='.length)));
  }
  config.headers = headers;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('partner-auth-storage');
      if (globalThis.location.pathname !== '/login') {
        globalThis.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export async function getCsrfCookie(): Promise<void> {
  await axios.get(`${API_BASE_URL}/sanctum/csrf-cookie`, { withCredentials: true });
}

export default api;
